import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import DropdownList from 'components/controls/DropdownList';
import { DatePicker, Checkbox } from 'antd';
import _notification from 'modules/notification';
import { Card, Table, Modal, Tag, Collapse, InputNumber } from 'antd';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopupWithInput from '../popup/ConfirmPopupWithInput';
import MyInput from 'components/controls/MyInput';
import TextArea from 'components/controls/TextArea';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import ImageToBase64 from '../../components/controls/ImageToBase64';
import FileUpload from '../../components/controls/FileUpload';
import InputCheck from 'components/controls/InputCheck';
import CKEditorComponent from '../../components/controls/CKEditorComponent';
import moment from 'moment';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';


const { Panel } = Collapse;

class PortalConfiguration_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            highlightedRowID: 0,
            data: [],
            exams: [],
            rowData: {},
            loading: false,
            showModel: false,
            showMessageBox: false,
            MinAgeError: "",
            MaxAgeError: "",
            logo1: "",
            logo2: "",
            totalRowCount: 0,
            AdvertisementDate: "",
            AdvertisementDateError: "",
            isViewResult: false,
            is_Aadhar_Authentication: false,
            is_Registration_Payment_Disabled: false
        };
    }

    componentDidMount() {
        this.getPortalConfigurations();
    }

    //API operations
    getPortalConfigurations = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let portalConfiguration = await _AdminService.GetPortalConfiguration();
                    //console.log("GetPortalConfiguration Data: ", portalConfiguration.data);

                    this.setState({
                        ...this.state,
                        rowData: portalConfiguration.data,
                        //totalRowCount: challanBankDetailsList.data.Obj.length,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            ...this.state.rowData
        }

        //console.log("Final data: ", params);

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.UpdatePortalConfiguration(params);
                    //console.log("Post response: ", response);
                    if (response.status == 200) {
                        _notification.showMessage('success', "Portal Configuration saved successfully.");
                        this.setState({
                            loading: false,
                        });
                        this.getPortalConfigurations();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    closeMessageBox = (value = false) => {
        this.setState({ showMessageBox: value });
    }

    onConfirmResetDatabase = async (input) => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.ResetDatabase(input);
                    //console.log("resetCode response: ", response);
                    if (response.status == 200 && response.data.IsSuccess) {
                        _notification.showMessage('success', "Reset Database Completed Successfully.");
                        this.setState({
                            loading: false,
                            showMessageBox: false
                        });
                    }
                    else {
                        this.setState({ loading: false, showMessageBox: false });
                        _notification.showMessage('error', response.data.Message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false, showMessageBox: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    onTextChange = ({ target: { name, value } }) => {
        if (name == 'Account_Number' && isNaN(value))
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });
    }

    onExamChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: event.target.value }
        });
    }

    onMinValueChange = (value) => {
        if (isNaN(value))
            return;

        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Min_Age_Criteria: value ? value : 0 }
        });
    };

    onKeyUp = (value) => {
        if (value.key != 'Backspace' && isNaN(value.key))
            value.preventDefault();

    };

    onMaxValueChange = (value) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Max_Age_Criteria: value }
        });
    };

    onConfigCheck = event => {
        //console.log(event.target.name, " ", this.state.rowData[event.target.name]);        
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [event.target.name]: !this.state.rowData[event.target.name] }
        });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            MinAgeError: "",
            MaxAgeError: "",
            AdvertisementDateError: ""
        });

        //console.log("Validate: ", body);

        let hasError = false;

        if (!body.Min_Age_Criteria) {
            this.setState({ MinAgeError: 'Please enter valid Min Age' });
            hasError = true
        }

        if (!body.Max_Age_Criteria) {
            this.setState({ MaxAgeError: 'Please enter valid Max Age' });
            hasError = true
        }

        if (body.Min_Age_Criteria && body.Max_Age_Criteria) {
            if (body.Min_Age_Criteria >= body.Max_Age_Criteria) {
                _notification.showMessage('error', "Minimum Age should be less than Maximum Age.");
                hasError = true
            }
        }

        if (!body.AdvertisementDate) {
            this.setState({ AdvertisementDateError: 'Please enter valid Advertisement Date' });
            hasError = true
        }

        return hasError;
    }

    onLogoOneSelect = (data) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, ["Portal_Logo"]: data }
        });
    }

    handleModelChange = (stateName, model) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [stateName]: model }
        });
    }

    onDateChange = (date, dateString) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, AdvertisementDate: date ? date.format("YYYY-MM-DDT00:00:00") : "" }
        });
    };
    onChange = (e) => {
        console.log(`checked = ${e.target.checked}`);
        this.setState({

            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, isViewResult: e.target.checked, }
        })
    };

    onChangeAadharAuthentication = (e) => {
        console.log(`checked = ${e.target.checked}`);
        this.setState({

            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, is_Aadhar_Authentication: e.target.checked, }
        })
    };

    onChangeDisabledRegistration = (e) => {
        console.log(`checked = ${e.target.checked}`);
        this.setState({

            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, is_Registration_Payment_Disabled: e.target.checked, }
        })
    };

    // Recruitment Candidate-List Publication Modernization phase.
    onRegistrationCutoffChange = (date) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Registration_Cutoff_DateTime: date ? date.format("YYYY-MM-DDTHH:mm:ss") : "" }
        });
    };

    onReconciliationWindowChange = (value) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Reconciliation_Window_Days: value }
        });
    };

    // Primary Result Automation & Interview Shortlisting phase: configurable interview-shortlist
    // multiplier (frozen rule: Interview Shortlist = Vacancy x Interview Ratio). Blank/null defaults
    // to 3 at computation time — see InterviewShortlistService, not here.
    onInterviewRatioChange = (value) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, Interview_Ratio: value }
        });
    };

    render() {

        if (this.state.loading)
            return <LoadingSpinner/>

        return (
            <div className="admin-container p-4">
                <PageHeader
                    title="Set Portal Configuration"
                    breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Settings' }, { label: 'Set Portal Configuration' }]}
                />
                <div className="ent-panel max1200 m-auto">
                    <h4 className="heading4">Set Portal Configuration</h4>
                    <div className="admin-inner-wrap p-3">

                        <div className="row flex-sm-row borderb mb-3 pb-3">
                            <div className="col-sm-4">
                                <label className="card-holder-name">Advertisement Date<span className="color-red">*</span></label>
                                <DatePicker onChange={this.onDateChange} format="DD-MMMM-YYYY" defaultValue={moment(this.state.rowData.AdvertisementDate).isValid() ? moment(this.state.rowData.AdvertisementDate) : ''} />
                                {this.state.AdvertisementDateError === "" ? "" : <label className="color-red d-block">{this.state.AdvertisementDateError}</label>}
                            </div>

                            <div className="col-sm-4">
                                <label className="card-holder-name" style={{ visibility: "hidden" }}>Declare Result</label>
                                <Checkbox onChange={this.onChange} checked={this.state.rowData.isViewResult} style={{ marginLeft: "10px", marginTop: "6px" }}>Declare Result</Checkbox>
                            </div>
                            <div className="col-sm-4">
                                <label className="card-holder-name" style={{ visibility: "hidden" }}>Disable Registration and Payment </label>
                                <Checkbox onChange={this.onChangeDisabledRegistration} checked={this.state.rowData.is_Registration_Payment_Disabled} style={{ marginLeft: "10px", marginTop: "6px" }}>Disable Registration and Payment</Checkbox>
                            </div>
                            <div className="col-sm-4" style={{ marginLeft: "33.3%" }}>
                                <label className="card-holder-name" style={{ visibility: "hidden" }}>Is Biometric Verification Required?</label>
                                <Checkbox onChange={this.onChangeAadharAuthentication} checked={this.state.rowData.is_Aadhar_Authentication} style={{ marginLeft: "10px", marginTop: "6px" }}>Is Biometric Verification Required?</Checkbox>
                            </div>
                        </div>

                        {/* Recruitment Candidate-List Publication Modernization phase: configuration-driven,
                            server-enforced registration closure. Registration_Cutoff_DateTime is entered
                            here as an IST wall-clock date+time (this platform is India-only) and is
                            enforced server-side in StudentService.StudentRegistration regardless of this
                            UI — the checkbox above remains an independent manual kill-switch; either one
                            closes registration. Reconciliation_Window_Days is informational/audit metadata
                            only, surfaced on the Eligible Candidate List screen. */}
                        <div className="row flex-sm-row borderb mb-3 pb-3">
                            <div className="col-sm-4">
                                <label className="card-holder-name">Registration Cutoff (Date &amp; Time, IST)</label>
                                <DatePicker
                                    showTime={{ format: 'HH:mm' }}
                                    format="DD-MMMM-YYYY HH:mm"
                                    onChange={this.onRegistrationCutoffChange}
                                    style={{ width: '100%' }}
                                    value={this.state.rowData.Registration_Cutoff_DateTime && moment(this.state.rowData.Registration_Cutoff_DateTime).isValid() ? moment(this.state.rowData.Registration_Cutoff_DateTime) : undefined}
                                    placeholder="No scheduled cutoff"
                                />
                                <label className="d-block" style={{ fontSize: '12px', color: '#888' }}>Leave blank for no scheduled cutoff (the checkbox above remains available as a manual override).</label>
                            </div>
                            <div className="col-sm-4">
                                <label className="card-holder-name">Reconciliation Window (Days)</label>
                                <InputNumber
                                    min={0}
                                    max={60}
                                    style={{ width: '100%' }}
                                    value={this.state.rowData.Reconciliation_Window_Days}
                                    onChange={this.onReconciliationWindowChange}
                                    placeholder="e.g. 7"
                                />
                            </div>
                            <div className="col-sm-4">
                                <label className="card-holder-name">Interview Ratio (Vacancy x N)</label>
                                <InputNumber
                                    min={1}
                                    max={20}
                                    style={{ width: '100%' }}
                                    value={this.state.rowData.Interview_Ratio}
                                    onChange={this.onInterviewRatioChange}
                                    placeholder="Defaults to 3 (i.e. 1:3)"
                                />
                                <label className="d-block" style={{ fontSize: '12px', color: '#888' }}>Interview Shortlist size = Vacancy x this ratio. Leave blank to use the default of 3.</label>
                            </div>
                        </div>

                        <div className="collapse-container">
                            <Collapse collapsible="header" defaultActiveKey={[1]} className="collapse-wrap" >
                                <Panel header="Global Portal Configuration" key="1">
                                    <div className="row flex-sm-row ">
                                        <div className="col-sm-4">
                                            <label htmlFor="category">Portal Logo<span className="color-red">*</span></label>
                                            <Card className='textAlignCenter uploadCard' style={this.state.logo1 ? { borderColor: 'red', borderWidth: '2px' } : {}}>
                                                <img src={this.state.rowData.Portal_Logo} alt="Logo not set" className='portalLogoStyle' />
                                                <ImageToBase64 onSelect={this.onLogoOneSelect} selectText="Select" removeText={this.state.rowData.Portal_Logo ? "Remove" : ""} logoFor="logo1"></ImageToBase64>
                                            </Card>
                                        </div>
                                        <div className="mb-2 col-sm-8">
                                            <label htmlFor="category">Copyright Text ©<span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="" model={this.state.rowData.Copyright_Text}
                                                modelName="Copyright_Text" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>
                                </Panel>

                                {/* <Panel header="Fields Configuration" key="2">
                                    <div className="row flex-sm-row ">
                                        <div className="col-sm-4 mt-2">
                                            <InputCheck
                                                id="isAadharMandatory"
                                                type="checkbox"
                                                label="Aadhaar Mandatory"
                                                className="mt-4"
                                                name="isAadharMandatory"
                                                value="false"
                                                onChange={this.onConfigCheck}
                                                checked={this.state.rowData.isAadharMandatory ? this.state.rowData.isAadharMandatory : false}
                                            />
                                        </div>
                                        <div className="col-sm-8 mt-2">
                                            <label htmlFor="category">If checked Aadhaar Number will become mandatory field at the time of candidate registration. Check this field if only unique candidates to be registered on the portal.</label>
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row ">
                                        <div className="col-sm-4 mt-2">
                                            <InputCheck
                                                id="isAgeRelaxationMandetory"
                                                type="checkbox"
                                                label="Show Age Relaxation Fields"
                                                className="mt-4"
                                                name="isAgeRelaxationMandetory"
                                                value="false"
                                                onChange={this.onConfigCheck}
                                                checked={this.state.rowData.isAgeRelaxationMandetory ? this.state.rowData.isAgeRelaxationMandetory : false}
                                            />
                                        </div>
                                        <div className="col-sm-8 mt-2">
                                            <label htmlFor="category">If checked Age and Other relaxation fields like (Ex Serviceman, Ladies, Handicaped, Earth Quake Affected, Player, Anshkalin) will be displayed at the time of candidate registration.</label>
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row ">
                                        <div className="col-sm-4 mt-2">
                                            <InputCheck
                                                id="isCategoryMandatory"
                                                type="checkbox"
                                                label="Show Category & Caste Fields"
                                                className="mt-4"
                                                name="isCategoryMandatory"
                                                value="false"
                                                onChange={this.onConfigCheck}
                                                checked={this.state.rowData.isCategoryMandatory ? this.state.rowData.isCategoryMandatory : false}
                                            />
                                        </div>
                                        <div className="col-sm-8 mt-2">
                                            <label htmlFor="category">If checked Category and Caste fields will be displayed and become mandatory at the time of candidate registration.</label>
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row pl-2 mb-2">
                                        <div className="col-sm-4 mt-2">
                                            <label htmlFor="category">Minimum Age<span className="color-red">*</span></label>
                                            <InputNumber className={this.state.MinAgeError ? "border-danger" : ""} min={10} max={30} defaultValue={this.state.rowData.Min_Age_Criteria} onKeyDown={this.onKeyUp} onChange={this.onMinValueChange} />
                                        </div>
                                        <div className="col-sm-8 mt-2">
                                            <label className='mt-3' htmlFor="category">Minimum age group allowed for candidate registration.</label>
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row pl-2 mb-2">
                                        <div className="col-sm-4 mt-2">
                                            <label htmlFor="category">Maximum Age<span className="color-red">*</span></label>
                                            <InputNumber className={this.state.MaxAgeError ? "border-danger" : ""} min={20} max={50} defaultValue={this.state.rowData.Max_Age_Criteria} onKeyDown={this.onKeyUp} onChange={this.onMaxValueChange} />
                                        </div>
                                        <div className="col-sm-8 mt-2">
                                            <label className='mt-3' htmlFor="category">Maximum age group allowed for candidate registration.</label>
                                        </div>
                                    </div>



                                </Panel> */}

                                <Panel header="Home Page Configuration" key="3">
                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Landing Page Header</label>
                                            <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.LandingPage_Header}
                                                modelName="LandingPage_Header" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Landing Page Middle</label>
                                            <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.LandingPage_Content}
                                                modelName="LandingPage_Content" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Landing Page Secondary Table</label>
                                            <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.LandingPage_SecondaryTable}
                                                modelName="LandingPage_SecondaryTable" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Landing Page Suchana</label>
                                            <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.LandingPage_Suchana}
                                                modelName="LandingPage_Suchana" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Landing Page Footer</label>
                                            <CKEditorComponent placeholderText="Exam Summary" model={this.state.rowData.LandingPage_Footer}
                                                modelName="LandingPage_Footer" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>
                                </Panel>

                                <Panel header="About Us, Contact Us, Privacy Policy, Terms & Conditions, Cancellation/Refund Policies." key="4">
                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >About Us</label>
                                            <CKEditorComponent placeholderText="About Us" model={this.state.rowData.AboutUs}
                                                modelName="AboutUs" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Contact Us</label>
                                            <CKEditorComponent placeholderText="Contact Us" model={this.state.rowData.ContactUs}
                                                modelName="ContactUs" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Privacy Policy</label>
                                            <CKEditorComponent placeholderText="Privacy Policy" model={this.state.rowData.PrivacyPolicy}
                                                modelName="PrivacyPolicy" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Terms & Conditions</label>
                                            <CKEditorComponent placeholderText="Term Condition" model={this.state.rowData.TermCondition}
                                                modelName="TermCondition" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label >Cancellation/Refund Policy</label>
                                            <CKEditorComponent placeholderText="Cancellation/Refund Policy" model={this.state.rowData.CancellationRefundPolicy}
                                                modelName="CancellationRefundPolicy" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>
                                </Panel>

                                <Panel header="Candidate Instructions/Notes" key="5">
                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="category">Exam Note on Summary Page<span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="Exam Note" model={this.state.rowData.Exam_note}
                                                modelName="Exam_note" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="category">Candidate Experience Note <span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="Exam Note" model={this.state.rowData.Candidate_Experience_Note}
                                                modelName="Candidate_Experience_Note" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="category">Print Challan Page Note<span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="Exam Note" model={this.state.rowData.ChallanPageNote}
                                                modelName="ChallanPageNote" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="category">Challan Payment Form Submit Note<span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="Exam Note" model={this.state.rowData.ChallanPaymentFormSubmitNote}
                                                modelName="ChallanPaymentFormSubmitNote" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>

                                    <div className="row flex-sm-row mb-4">
                                        <div className="mb-2 col-sm-12">
                                            <label htmlFor="category">Online Payment Form Submit Note<span className="color-red">*</span></label>
                                            <CKEditorComponent placeholderText="Exam Note" model={this.state.rowData.OnlinePaymentFormSubmitNote}
                                                modelName="OnlinePaymentFormSubmitNote" handleModelChange={this.handleModelChange} />
                                        </div>
                                    </div>
                                </Panel>

                                <Panel header="System Configuration" key="6">
                                    <div className="ent-danger-banner">
                                        <span className="ent-danger-icon" aria-hidden="true">&#9888;</span>
                                        <div>
                                            <div className="ent-danger-title">Reset Database — Irreversible Action</div>
                                            <div className="ent-danger-description">This will reset the database to blank, deleting all Candidates, Qualification, Reservation, Payment, Center, Batch, Assigned Centers, Generated Roll Numbers, Posts, Challan, and related data. This activity cannot be reversed — take a backup of the existing database before performing it.</div>
                                        </div>
                                    </div>
                                    <div className="row flex-sm-row ">
                                        <div className="col-sm-3 align-self-center ">
                                            <button type="button" onClick={() => this.closeMessageBox(true)} className="btn-tertiary button-global button-danger autoHeight">Reset Database</button>
                                        </div>
                                    </div>
                                </Panel>
                            </Collapse>
                        </div>

                    </div>
                    <div className="col-sm-12 buttonAlignCenter pt-4" >
                        <button type="button" onClick={this.handleUpdate} className="button-global button-primary large autoHeight">Update Portal Configuration</button>
                    </div>
                </div>
                {this.state.showMessageBox &&
                    <Modal
                        centered={true}
                        width={400}
                        className="modelPopAnt admin-popup"
                        visible={this.state.showMessageBox}
                        onCancel={() => this.closeMessageBox(false)}
                        footer={false}
                    >
                        <ConfirmPopupWithInput
                            onCancel={() => this.closeMessageBox(false)}
                            onOk={this.onConfirmResetDatabase}
                            popupData={""}
                            header={<div className="heading5">Reset Database</div>}
                            message="Reset Database activity cannot be reversed, please take a backup of existing database before performing this activity."
                            noButtonText="Cancel"
                            yesButtonText="Reset"
                        />
                    </Modal>}
            </div>
        )
    };
}

export default PortalConfiguration_new;